
    import {useStore} from "@/store";
    import {defineComponent, computed, ComputedRef, watch, reactive} from "vue";

    interface State {
        remarks: string;
    }
    export default defineComponent({
        name: "remarksMsg",
        setup() {
            let state: State = reactive({
                remarks: '',
            })
            let store = useStore()
            let dataInfo: ComputedRef<{}> = computed<{}>(() => store.state.dataInfo)
            watch(dataInfo, (data: any) => {
                const {carSummaryInfo} = data
                state.remarks = carSummaryInfo
            })
            return {
                state
            }
        }
    })
